import update from 'immutability-helper';
import {
  ON_APPLICATION_TEMPLATE_FETCH_REQUEST,
  ON_APPLICATION_TEMPLATE_FETCH_SUCCESS,
  ON_APP_DETAILS_FETCH_REQUEST,
  ON_APP_DETAILS_FETCH_SUCCESS,
} from '../actions/types';
import {createReducer} from '../utils';

const initialState = {
  template: {
    primaryColor: '#f15a24',
    secondaryColor: '#29abe2',
    backgroundColor: '#cdcecf',
  },
  details: {},
  isTemplateFetching: true,
  isDetailsFetching: false,
  isRedemption: false,
};

const applicationReducer = createReducer(initialState, {
  [ON_APPLICATION_TEMPLATE_FETCH_REQUEST]: state => (
    update(state, {
      isTemplateFetching: {$set: true},
    })
  ),
  [ON_APPLICATION_TEMPLATE_FETCH_SUCCESS]: (state, payload) => {
    const {template} = payload;
    return update(state, {
      isTemplateFetching: {$set: false},
      template: {$set: template},
    });
  },
  [ON_APP_DETAILS_FETCH_SUCCESS]: (state, payload) => {
    const {details} = payload;
    return update(state, {
      isDetailsFetching: {$set: false},
      details: {$set: details},
    });
  },
  [ON_APP_DETAILS_FETCH_REQUEST]: state => (
    update(state, {
      isDetailsFetching: {$set: true},
    })
  ),
  '@@router/LOCATION_CHANGE': state => update(state, {isDetailsFetching: {$set: false}}),
});

export default applicationReducer;
